import React, { Component } from 'react';
import PropTypes from 'prop-types';

import defaultClassNames from './classNames.js';
import { SPACE, ENTER } from './keys.js';
import s from './styleModule.scss';

export default class Navbar extends Component {
  static propTypes = {
    classNames: PropTypes.shape({
      navBar: PropTypes.string.isRequired,
      navButtonPrev: PropTypes.string.isRequired,
      navButtonNext: PropTypes.string.isRequired,
    }),
    className: PropTypes.string,
    showPreviousButton: PropTypes.bool,
    showNextButton: PropTypes.bool,
    onPreviousClick: PropTypes.func,
    onNextClick: PropTypes.func,
    onPreviousYearClick: PropTypes.func,
    onNextYearClick: PropTypes.func,
    dir: PropTypes.string,
    labels: PropTypes.shape({
      previousMonth: PropTypes.string.isRequired,
      nextMonth: PropTypes.string.isRequired,
    }),
  };

  static defaultProps = {
    classNames: defaultClassNames,
    dir: 'ltr',
    labels: {
      previousMonth: 'Previous Month',
      nextMonth: 'Next Month',
    },
    showPreviousButton: true,
    showNextButton: true,
  };

  shouldComponentUpdate(nextProps) {
    return (
      nextProps.labels !== this.props.labels ||
      nextProps.dir !== this.props.dir ||
      this.props.showPreviousButton !== nextProps.showPreviousButton ||
      this.props.showNextButton !== nextProps.showNextButton
    );
  }

  handleNextClick = () => {
    if (this.props.onNextClick) {
      this.props.onNextClick();
    }
  };

  handlePreviousClick = () => {
    if (this.props.onPreviousClick) {
      this.props.onPreviousClick();
    }
  };

  handleNextYearClick = () => {
    if (this.props.onNextClick) {
      this.props.onNextYearClick();
    }
  };

  handlePreviousYearClick = () => {
    if (this.props.onPreviousClick) {
      this.props.onPreviousYearClick();
    }
  };

  handleNextKeyDown = e => {
    if (e.keyCode !== ENTER && e.keyCode !== SPACE) {
      return;
    }
    e.preventDefault();
    this.handleNextClick();
  };

  handlePreviousKeyDown = e => {
    if (e.keyCode !== ENTER && e.keyCode !== SPACE) {
      return;
    }
    e.preventDefault();
    this.handlePreviousClick();
  };

  render() {
    const {
      classNames,
      className,
      showPreviousButton,
      showNextButton,
      labels,
      dir,
    } = this.props;

    let previousClickHandler;
    let previousYearClickHandler;
    let nextClickHandler;
    let nextYearClickHandler;
    let previousKeyDownHandler;
    let nextKeyDownHandler;
    let shouldShowPrevious;
    let shouldShowNext;

    if (dir === 'rtl') {
      previousClickHandler = this.handleNextClick;
      previousYearClickHandler = this.handleNextYearClick;
      nextClickHandler = this.handlePreviousClick;
      nextYearClickHandler = this.handlePreviousYearClick
      previousKeyDownHandler = this.handleNextKeyDown;
      nextKeyDownHandler = this.handlePreviousKeyDown;
      shouldShowNext = showPreviousButton;
      shouldShowPrevious = showNextButton;
    } else {
      previousClickHandler = this.handlePreviousClick;
      previousYearClickHandler = this.handlePreviousYearClick;
      nextClickHandler = this.handleNextClick;
      nextYearClickHandler = this.handleNextYearClick;

      previousKeyDownHandler = this.handlePreviousKeyDown;
      nextKeyDownHandler = this.handleNextKeyDown;
      shouldShowNext = showNextButton;
      shouldShowPrevious = showPreviousButton;
    }

    // const previousClassName = shouldShowPrevious
    //   ? classNames.navButtonPrev
    //   : `${classNames.navButtonPrev} ${
    //       classNames.navButtonInteractionDisabled
    //     }`;

    const previousClassName = shouldShowPrevious
      ? [s.NavButton, s.NavButton__prev].join(' ')
      : [s.NavButton, s.NavButton__prev, s.NavButton_interactionDisabled].join(' ');

    // const nextClassName = shouldShowNext
    //   ? classNames.navButtonNext
    //   : `${classNames.navButtonNext} ${
    //       classNames.navButtonInteractionDisabled
    //     }`;
    const nextClassName = shouldShowNext
      ? [s.NavButton, s.NavButton__next].join(' ')
      : [s.NavButton, s.NavButton__next, s.NavButton_interactionDisabled].join(' ');

    const previousYearClassName = shouldShowPrevious
      ? [s.NavButton, s.NavButton__prev_year].join(' ')
      : [s.NavButton, s.NavButton__prev, s.NavButton_interactionDisabled].join(' ');

    const nextYearClassName = shouldShowNext
      ? [s.NavButton, s.NavButton__next_year].join(' ')
      : [s.NavButton, s.NavButton__next, s.NavButton_interactionDisabled].join(' ');

    const previousButton = (
      <span
        tabIndex="0"
        role="button"
        aria-label={labels.previousMonth}
        key="previous"
        className={previousClassName}
        onKeyDown={shouldShowPrevious ? previousKeyDownHandler : undefined}
        onClick={shouldShowPrevious ? previousClickHandler : undefined}
      />
    );

    const nextButton = (
      <span
        tabIndex="0"
        role="button"
        aria-label={labels.nextMonth}
        key="right"
        className={nextClassName}
        onKeyDown={shouldShowNext ? nextKeyDownHandler : undefined}
        onClick={shouldShowNext ? nextClickHandler : undefined}
      />
    );

    const previousYearButton = (
      <span
        tabIndex="0"
        role="button"
        aria-label={labels.previousMonth}
        key="previous year"
        className={previousYearClassName}
        onClick={shouldShowPrevious ? previousYearClickHandler : undefined}
      />
    );

    const nextYearButton = (
      <span
        tabIndex="0"
        role="button"
        aria-label={labels.nextMonth}
        key="right year"
        className={nextYearClassName}
        onClick={shouldShowNext ? nextYearClickHandler : undefined}
      />
    );

    return (
      // <div className={className || classNames.navBar}>
      <div className={s.NavBar}>
        {dir === 'rtl'
          ? [nextYearButton, nextButton, previousButton, previousYearButton]
          : [previousYearButton, previousButton, nextButton, nextYearButton]}
      </div>
    );
  }
}
